<div id="academy-courses" class="page-layout simple">

  <div class="header primary p-16 p-sm-24" fxLayout="column" fxLayoutAlign="center center">

    <div class="hero-text" fxLayout="row" fxLayoutAlign="start center">
      <button mat-icon-button class="mr-16" (click)="regresarDetail()">
              <mat-icon>arrow_back</mat-icon>
      </button>
      <h1 [@animate]="{value:'*',params:{delay:'100ms', y:'25px'}}">
        {{'NAV.CLOUD.TITULO' | translate}}
      </h1>
    </div>

  </div>
  <div class="content p-24">

    <div fxLayout="column" fxLayoutAlign="center">
      <div class="courses" fxLayout="row wrap" fxLayoutAlign="center" [@animateStagger]="{value:'50'}">
        <ng-container *ngIf="cargando">
          <div fxFlex="100" fxFlex.gt-sm="33" fxLayout="column" fxLayoutAlign="center stretch" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
            <div fxLayout="column" fxLayoutAlign="space-between center">
              <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
              <h2>{{'WIZARD.CARGANDO' | translate}}</h2>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="!cargando">

          <div *ngFor="let producto of productosAsignados; let i = index; let last = last; let first = first;" class="course" fxFlex="100" fxFlex.gt-sm="33" [ngClass]="web" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">

            <div class="cursoCard" fxFlex="100" [ngClass]="producto.category" [@animate]="{value:'*',params:{y:'100%'}}">
              <div class="course-content" fxLayout="column" fxFlex="1 1 auto">
                <div class="header primary" fxLayout="row" fxLayoutAlign="center center">
                  <div class="category" fxFlex></div>
                </div>

                <div class="content  p-20 m-20" fxLayout="column" fxLayoutAlign="center center" fxFlex="1 1 auto">
                  <div class="h1">{{'NAV.CLOUD.TITULO' | translate}} v{{producto.nombre}}</div>
                </div>

                <div class="footer" fxLayout="row" fxLayoutAlign="center center">
                  <button mat-button class="accent rndBt" fxFlex="100" (click)="navigateTo(producto);">{{'WIZARD.LANDING.IR' | translate}}</button>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>

    </div>
  </div>
</div>
